import React, { useEffect, useRef } from "react";
import ReactPlayer from "react-player";

export default function VideoPlayer({
  playbackId,
  playBackDuration,
  isAutoPlay,
}) {
  const videoRef = useRef(null);
  const src = `https://stream.mux.com/${playbackId}.m3u8`;

  useEffect(() => {
    if (videoRef.current) {
      const video = videoRef.current;
      if (playBackDuration) {
        video.seekTo(playBackDuration);
      }
    }
  }, [playBackDuration]);

  return (
    <ReactPlayer
      className="react-player"
      url={src}
      ref={videoRef}
      width="100%"
      height="100%"
      controls
      playing={isAutoPlay}
    />
  );
}
